import axios from '../../axios';

import * as actionTypes from '../constants/actionTypes';

import { AppDispatch } from '../../../store';
import {
  DataLookup,
  DataLookupTag,
  GetAdditionalInterestsLookupRequest,
  GetAgentsLookupRequest,
  GetBoatsLookupRequest,
  GetBusinessAutoAcord137sLookupRequest,
  GetClaimsLookupRequest,
  GetCommercialUmbrellasLookupRequest,
  GetDataLookupRequest,
  GetDataLookupSearchRequest,
  GetDriversLookupRequest,
  GetEquipmentsLookupRequest,
  GetFormNameRequest,
  GetGeneralLiabilitiesLookupRequest,
  GetInsuredContactsLookupRequest,
  GetMotorTruckCargoLookupRequest,
  GetPendingCancellationsLookupRequest,
  GetPersonalUmbrellasLookupRequest,
  GetPoliciesLookupRequest,
  GetPropertiesLookupRequest,
  GetScheduleOfHazardsLookupRequest,
  GetSignaturesLookupRequest,
  GetTruckingCompaniesForTypesRequest,
  GetTruckingCompanyContactsLookupRequest,
  GetVehiclesLookupRequest,
  GetWorkersCompensationsLookupRequest,
  LineOfBusiness,
  LobClass,
  OpportunityStage,
  ProspectStatus,
  QuoteStage,
  ReplaceMessagePlaceholdersRequest,
  StatusOfAgencyModules,
  TruckingCompany,
  UserInfo,
} from '../../models';
import { validateObj } from '../../utils';

const getStatesStart = () => {
  return {
    type: actionTypes.GET_STATES_START,
  };
};

const getStatesSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.GET_STATES_SUCCESS,
    data: data,
  };
};

const getStatesFail = (error: any) => {
  return {
    type: actionTypes.GET_STATES_FAIL,
    error: error,
  };
};

export const getStates = (params: GetDataLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getStatesStart());

      const url = `/shared/get-states`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getStatesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getStatesFail(err));
          reject(err);
        });
    });
  };
};

const getCarriersStart = () => {
  return {
    type: actionTypes.GET_CARRIERS_START,
  };
};

const getCarriersSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.GET_CARRIERS_SUCCESS,
    data: data,
  };
};

const getCarriersFail = (error: any) => {
  return {
    type: actionTypes.GET_CARRIERS_FAIL,
    error: error,
  };
};

export const getCarriers = (params: GetTruckingCompaniesForTypesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getCarriersStart());

      const url = '/shared/get-carriers';

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getCarriersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getCarriersFail(err));
          reject(err);
        });
    });
  };
};

const getLocationsStart = () => {
  return {
    type: actionTypes.GET_LOCATIONS_START,
  };
};

const getLocationsSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.GET_LOCATIONS_SUCCESS,
    data: data,
  };
};

const getLocationsFail = (error: any) => {
  return {
    type: actionTypes.GET_LOCATIONS_FAIL,
    error: error,
  };
};

export const getLocations = (params: GetDataLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getLocationsStart());

      const url = '/shared/get-locations';

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getLocationsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getLocationsFail(err));
          reject(err);
        });
    });
  };
};

const getLOBClassesStart = () => {
  return {
    type: actionTypes.GET_LOB_CLASSES_START,
  };
};

const getLOBClassesSuccess = (data: Array<LobClass>) => {
  return {
    type: actionTypes.GET_LOB_CLASSES_SUCCESS,
    data: data,
  };
};

const getLOBClassesFail = (error: any) => {
  return {
    type: actionTypes.GET_LOB_CLASSES_FAIL,
    error: error,
  };
};

export const getLOBClasses = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<LobClass>>((resolve, reject) => {
      dispatch(getLOBClassesStart());

      const url = `/shared/get-lob-classes`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getLOBClassesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getLOBClassesFail(err));
          reject(err);
        });
    });
  };
};

const getLinesOfBusinessStart = () => {
  return {
    type: actionTypes.GET_LINES_OF_BUSINESS_START,
  };
};

const getLinesOfBusinessSuccess = (data: Array<LineOfBusiness>) => {
  return {
    type: actionTypes.GET_LINES_OF_BUSINESS_SUCCESS,
    data: data,
  };
};

const getLinesOfBusinessFail = (error: any) => {
  return {
    type: actionTypes.GET_LINES_OF_BUSINESS_FAIL,
    error: error,
  };
};

export const getLinesOfBusiness = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<LineOfBusiness>>((resolve, reject) => {
      dispatch(getLinesOfBusinessStart());

      const url = `/shared/get-lines-of-business`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getLinesOfBusinessSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getLinesOfBusinessFail(err));
          reject(err);
        });
    });
  };
};

const getReferralSourcesStart = () => {
  return {
    type: actionTypes.GET_REFERRAL_SOURCES_START,
  };
};

const getReferralSourcesSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.GET_REFERRAL_SOURCES_SUCCESS,
    data: data,
  };
};

const getReferralSourcesFail = (error: any) => {
  return {
    type: actionTypes.GET_REFERRAL_SOURCES_FAIL,
    error: error,
  };
};

export const getReferralSources = (params: GetTruckingCompaniesForTypesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getReferralSourcesStart());

      const url = '/shared/get-referral-sources';

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getReferralSourcesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getReferralSourcesFail(err));
          reject(err);
        });
    });
  };
};

const getTagsStart = () => {
  return {
    type: actionTypes.GET_TAGS_START,
  };
};

const getTagsSuccess = (data: DataLookupTag) => {
  return {
    type: actionTypes.GET_TAGS_SUCCESS,
    data: data,
  };
};

const getTagsFail = (error: any) => {
  return {
    type: actionTypes.GET_TAGS_FAIL,
    error: error,
  };
};

export const getTags = (params: GetDataLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookupTag>((resolve, reject) => {
      dispatch(getTagsStart());
      const url = `/shared/get-tags`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getTagsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getTagsFail(err));
          reject(err);
        });
    });
  };
};

const getQuoteStagesStart = () => {
  return {
    type: actionTypes.GET_QUOTE_STAGES_START,
  };
};

const getQuoteStagesSuccess = (data: Array<QuoteStage>) => {
  return {
    type: actionTypes.GET_QUOTE_STAGES_SUCCESS,
    data: data,
  };
};

const getQuoteStagesFail = (error: any) => {
  return {
    type: actionTypes.GET_QUOTE_STAGES_FAIL,
    error: error,
  };
};

export const getQuoteStages = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<QuoteStage>>((resolve, reject) => {
      dispatch(getQuoteStagesStart());

      const url = `/shared/get-quote-stages`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getQuoteStagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getQuoteStagesFail(err));
          reject(err);
        });
    });
  };
};

const getMgasStart = () => {
  return {
    type: actionTypes.GET_MGAS_START,
  };
};

const getMgasSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.GET_MGAS_SUCCESS,
    data: data,
  };
};

const getMgasFail = (error: any) => {
  return {
    type: actionTypes.GET_MGAS_FAIL,
    error: error,
  };
};

export const getMgas = (params: GetTruckingCompaniesForTypesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getMgasStart());

      const url = '/shared/get-mgas';

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getMgasSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getMgasFail(err));
          reject(err);
        });
    });
  };
};

const getProspectStatusesStart = () => {
  return {
    type: actionTypes.GET_PROSPECT_STATUSES_START,
  };
};

const getProspectStatusesSuccess = (data: Array<ProspectStatus>) => {
  return {
    type: actionTypes.GET_PROSPECT_STATUSES_SUCCESS,
    data: data,
  };
};

const getProspectStatusesFail = (error: any) => {
  return {
    type: actionTypes.GET_PROSPECT_STATUSES_FAIL,
    error: error,
  };
};

export const getProspectStatuses = (params: GetDataLookupSearchRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<ProspectStatus>>((resolve, reject) => {
      dispatch(getProspectStatusesStart());

      const url = `/shared/get-prospect-statuses`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getProspectStatusesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getProspectStatusesFail(err));
          reject(err);
        });
    });
  };
};

const getParentCarriersStart = () => {
  return {
    type: actionTypes.GET_PARENT_CARRIERS_START,
  };
};

const getParentCarriersSuccess = (data: Array<TruckingCompany>) => {
  return {
    type: actionTypes.GET_PARENT_CARRIERS_SUCCESS,
    data: data,
  };
};

const getParentCarriersFail = (error: any) => {
  return {
    type: actionTypes.GET_PARENT_CARRIERS_FAIL,
    error: error,
  };
};

export const getParentCarriers = (params: GetDataLookupSearchRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<TruckingCompany>>((resolve, reject) => {
      dispatch(getParentCarriersStart());

      const url = `/shared/get-parent-carriers`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getParentCarriersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getParentCarriersFail(err));
          reject(err);
        });
    });
  };
};

const getOpportunityStagesStart = () => {
  return {
    type: actionTypes.GET_OPPORTUNITY_STAGES_START,
  };
};

const getOpportunityStagesSuccess = (data: Array<OpportunityStage>) => {
  return {
    type: actionTypes.GET_OPPORTUNITY_STAGES_SUCCESS,
    data: data,
  };
};

const getOpportunityStagesFail = (error: any) => {
  return {
    type: actionTypes.GET_OPPORTUNITY_STAGES_FAIL,
    error: error,
  };
};

export const getOpportunityStages = (params: GetDataLookupSearchRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<OpportunityStage>>((resolve, reject) => {
      dispatch(getOpportunityStagesStart());

      const url = `/shared/get-opportunity-stages`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getOpportunityStagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getOpportunityStagesFail(err));
          reject(err);
        });
    });
  };
};

const getAgencyNameStart = () => {
  return {
    type: actionTypes.GET_AGENCY_NAME_START,
  };
};

const getAgencyNameSuccess = (data: string) => {
  return {
    type: actionTypes.GET_AGENCY_NAME_SUCCESS,
    data: data,
  };
};

const getAgencyNameFail = (error: any) => {
  return {
    type: actionTypes.GET_AGENCY_NAME_FAIL,
    error: error,
  };
};

export const getAgencyName = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<string>((resolve, reject) => {
      dispatch(getAgencyNameStart());

      const url = `/shared/get-agency-name`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getAgencyNameSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAgencyNameFail(err));
          reject(err);
        });
    });
  };
};

const getPoliciesLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_POLICIES_LOOKUP_START,
  };
};

const getPoliciesLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_POLICIES_LOOKUP_SUCCESS,
    data,
  };
};

const getPoliciesLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_POLICIES_LOOKUP_FAIL,
    error,
  };
};

export const getPoliciesLookup = (params: GetPoliciesLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getPoliciesLookupStart());

      const url = `/shared/get-policies-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getPoliciesLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getPoliciesLookupFail(err));
          reject(err);
        });
    });
  };
};

const getMaxFileUploadSizeStart = () => {
  return {
    type: actionTypes.GET_MAX_FILE_UPLOAD_SIZE_START,
  };
};

const getMaxFileUploadSizeSuccess = (data: number) => {
  return {
    type: actionTypes.GET_MAX_FILE_UPLOAD_SIZE_SUCCESS,
    data,
  };
};

const getMaxFileUploadSizeFail = (error: any) => {
  return {
    type: actionTypes.GET_MAX_FILE_UPLOAD_SIZE_FAIL,
    error,
  };
};

export const getMaxFileUploadSize = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<number>((resolve, reject) => {
      dispatch(getMaxFileUploadSizeStart());
      const url = `/shared/get-max-file-upload-size`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getMaxFileUploadSizeSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getMaxFileUploadSizeFail(err));
          reject(err);
        });
    });
  };
};

const getStatusOfAgencyModulesStart = () => {
  return {
    type: actionTypes.GET_STATUS_OF_AGENCY_MODULES_START,
  };
};

const getStatusOfAgencyModulesSuccess = (data: StatusOfAgencyModules) => {
  return {
    type: actionTypes.GET_STATUS_OF_AGENCY_MODULES_SUCCESS,
    data,
  };
};

const getStatusOfAgencyModulesFail = (error: any) => {
  return {
    type: actionTypes.GET_STATUS_OF_AGENCY_MODULES_FAIL,
    error,
  };
};

export const getStatusOfAgencyModules = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<StatusOfAgencyModules>((resolve, reject) => {
      dispatch(getStatusOfAgencyModulesStart());
      const url = `/shared/get-status-of-agency-modules`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getStatusOfAgencyModulesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getStatusOfAgencyModulesFail(err));
          reject(err);
        });
    });
  };
};

const getInsuredsByAgencyStart = () => {
  return {
    type: actionTypes.SHARED_GET_INSUREDS_BY_AGENCY_START,
  };
};

const getInsuredsByAgencySuccess = (data: Array<TruckingCompany>) => {
  return {
    type: actionTypes.SHARED_GET_INSUREDS_BY_AGENCY_SUCCESS,
    data,
  };
};

const getInsuredsByAgencyFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_INSUREDS_BY_AGENCY_FAIL,
    error,
  };
};

export const getInsuredsByAgency = (params: GetDataLookupSearchRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<TruckingCompany>>((resolve, reject) => {
      dispatch(getInsuredsByAgencyStart());

      const url = `/shared/get-insureds-by-agency`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getInsuredsByAgencySuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getInsuredsByAgencyFail(err));
          reject(err);
        });
    });
  };
};

const getClaimsStart = () => {
  return {
    type: actionTypes.SHARED_GET_CLAIMS_START,
  };
};

const getClaimsSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_CLAIMS_SUCCESS,
    data,
  };
};

const getClaimsFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_CLAIMS_FAIL,
    error,
  };
};

export const getClaims = (params: GetClaimsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getClaimsStart());

      const url = `/shared/get-claims-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getClaimsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getClaimsFail(err));
          reject(err);
        });
    });
  };
};

const getInsuredContactsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_INSURED_CONTACTS_LOOKUP_START,
  };
};

const getInsuredContactsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_INSURED_CONTACTS_LOOKUP_SUCCESS,
    data,
  };
};

const getInsuredContactsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_INSURED_CONTACTS_LOOKUP_FAIL,
    error,
  };
};

export const getInsuredContactsLookup = (params: GetInsuredContactsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getInsuredContactsLookupStart());

      const url = `/shared/get-insured-contacts-lookup`;

      params.ownersOnly = false;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getInsuredContactsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getInsuredContactsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getInsuredContactsOwnersLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_START,
  };
};

const getInsuredContactsOwnersLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_SUCCESS,
    data,
  };
};

const getInsuredContactsOwnersLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_FAIL,
    error,
  };
};

export const getInsuredContactsOwnersLookup = (params: GetInsuredContactsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getInsuredContactsOwnersLookupStart());

      const url = `/shared/get-insured-contacts-lookup`;

      params.ownersOnly = true;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getInsuredContactsOwnersLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getInsuredContactsOwnersLookupFail(err));
          reject(err);
        });
    });
  };
};

const getDriversLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_DRIVERS_LOOKUP_START,
  };
};

const getDriversLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_DRIVERS_LOOKUP_SUCCESS,
    data,
  };
};

const getDriversLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_DRIVERS_LOOKUP_FAIL,
    error,
  };
};

export const getDriversLookup = (params: GetDriversLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getDriversLookupStart());

      const url = `/shared/get-drivers-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getDriversLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getDriversLookupFail(err));
          reject(err);
        });
    });
  };
};

const getVehiclesLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_VEHICLES_LOOKUP_START,
  };
};

const getVehiclesLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_VEHICLES_LOOKUP_SUCCESS,
    data,
  };
};

const getVehiclesLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_VEHICLES_LOOKUP_FAIL,
    error,
  };
};

export const getVehiclesLookup = (params: GetVehiclesLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getVehiclesLookupStart());

      const url = `/shared/get-vehicles-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getVehiclesLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getVehiclesLookupFail(err));
          reject(err);
        });
    });
  };
};

const replaceMessagePlaceholdersStart = () => {
  return {
    type: actionTypes.REPLACE_MESSAGE_PLACEHOLDERS_START,
  };
};

const replaceMessagePlaceholdersSuccess = (data: string) => {
  return {
    type: actionTypes.REPLACE_MESSAGE_PLACEHOLDERS_SUCCESS,
    data: data,
  };
};

const replaceMessagePlaceholdersFail = (error: any) => {
  return {
    type: actionTypes.REPLACE_MESSAGE_PLACEHOLDERS_FAIL,
    error: error,
  };
};

export const replaceMessagePlaceholders = (params: ReplaceMessagePlaceholdersRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<string>((resolve, reject) => {
      dispatch(replaceMessagePlaceholdersStart());

      const url = `/shared/replace-message-placeholders`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(replaceMessagePlaceholdersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(replaceMessagePlaceholdersFail(err));
          reject(err);
        });
    });
  };
};

const getMotorTruckCargoLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_START,
  };
};

const getMotorTruckCargoLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_SUCCESS,
    data,
  };
};

const getMotorTruckCargoLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_FAIL,
    error,
  };
};

export const getMotorTruckCargoLookup = (params: GetMotorTruckCargoLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getMotorTruckCargoLookupStart());

      const url = `/shared/get-motor-truck-cargo-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getMotorTruckCargoLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getMotorTruckCargoLookupFail(err));
          reject(err);
        });
    });
  };
};

const getPendingCancellationsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_START,
  };
};

const getPendingCancellationsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_SUCCESS,
    data,
  };
};

const getPendingCancellationsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_FAIL,
    error,
  };
};

export const getPendingCancellationsLookup = (params: GetPendingCancellationsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getPendingCancellationsLookupStart());

      const url = `/shared/get-pending-cancellations-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getPendingCancellationsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getPendingCancellationsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getTruckingCompanyContactsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_START,
  };
};

const getTruckingCompanyContactsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_SUCCESS,
    data,
  };
};

const getTruckingCompanyContactsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_FAIL,
    error,
  };
};

export const getTruckingCompanyContactsLookup = (params: GetTruckingCompanyContactsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getTruckingCompanyContactsLookupStart());

      const url = `/shared/get-trucking-company-contacts-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getTruckingCompanyContactsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getTruckingCompanyContactsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getWorkersCompensationsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_START,
  };
};

const getWorkersCompensationsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_SUCCESS,
    data,
  };
};

const getWorkersCompensationsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_FAIL,
    error,
  };
};

export const getWorkersCompensationsLookup = (params: GetWorkersCompensationsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getWorkersCompensationsLookupStart());

      const url = `/shared/get-workers-compensations-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getWorkersCompensationsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getWorkersCompensationsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getPropertiesLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_PROPERTIES_LOOKUP_START,
  };
};

const getPropertiesLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_PROPERTIES_LOOKUP_SUCCESS,
    data,
  };
};

const getPropertiesLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_PROPERTIES_LOOKUP_FAIL,
    error,
  };
};

export const getPropertiesLookup = (params: GetPropertiesLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getPropertiesLookupStart());

      const url = `/shared/get-properties-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getPropertiesLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getPropertiesLookupFail(err));
          reject(err);
        });
    });
  };
};

const getAdditionalInterestsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_START,
  };
};

const getAdditionalInterestsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_SUCCESS,
    data,
  };
};

const getAdditionalInterestsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_FAIL,
    error,
  };
};

export const getAdditionalInterestsLookup = (params: GetAdditionalInterestsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getAdditionalInterestsLookupStart());

      const url = `/shared/get-additional-interests-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getAdditionalInterestsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAdditionalInterestsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getGeneralLiabilitiesLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_GENERAL_LIABILITIES_LOOKUP_START,
  };
};

const getGeneralLiabilitiesLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_GENERAL_LIABILITIES_LOOKUP_SUCCESS,
    data,
  };
};

const getGeneralLiabilitiesLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_GENERAL_LIABILITIES_LOOKUP_FAIL,
    error,
  };
};

export const getGeneralLiabilitiesLookup = (params: GetGeneralLiabilitiesLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getGeneralLiabilitiesLookupStart());

      const url = `/shared/get-general-liabilities-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getGeneralLiabilitiesLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getGeneralLiabilitiesLookupFail(err));
          reject(err);
        });
    });
  };
};

const getScheduleOfHazardsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_START,
  };
};

const getScheduleOfHazardsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_SUCCESS,
    data,
  };
};

const getScheduleOfHazardsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_FAIL,
    error,
  };
};

export const getScheduleOfHazardsLookup = (params: GetScheduleOfHazardsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getScheduleOfHazardsLookupStart());

      const url = `/shared/get-schedule-of-hazards-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getScheduleOfHazardsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getScheduleOfHazardsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getEquipmentsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_EQUIPMENTS_LOOKUP_START,
  };
};

const getEquipmentsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_EQUIPMENTS_LOOKUP_SUCCESS,
    data,
  };
};

const getEquipmentsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_EQUIPMENTS_LOOKUP_FAIL,
    error,
  };
};

export const getEquipmentsLookup = (params: GetEquipmentsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getEquipmentsLookupStart());

      const url = `/shared/get-equipments-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getEquipmentsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getEquipmentsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getAgentsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_AGENTS_LOOKUP_START,
  };
};

const getAgentsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_AGENTS_LOOKUP_SUCCESS,
    data,
  };
};

const getAgentsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_AGENTS_LOOKUP_FAIL,
    error,
  };
};

export const getAgentsLookup = (params: GetAgentsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getAgentsLookupStart());

      const url = `/shared/get-agents-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getAgentsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAgentsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getQuotesLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_QUOTES_LOOKUP_START,
  };
};

const getQuotesLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_QUOTES_LOOKUP_SUCCESS,
    data,
  };
};

const getQuotesLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_QUOTES_LOOKUP_FAIL,
    error,
  };
};

export const getQuotesLookup = (params: GetPoliciesLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getQuotesLookupStart());
      const url = `/shared/get-policies-lookup`;

      params.onlyQuote = true;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getQuotesLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getQuotesLookupFail(err));
          reject(err);
        });
    });
  };
};

const getSignaturesLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_SIGNATURES_LOOKUP_START,
  };
};

const getSignaturesLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_SIGNATURES_LOOKUP_SUCCESS,
    data,
  };
};

const getSignaturesLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_SIGNATURES_LOOKUP_FAIL,
    error,
  };
};

export const getSignaturesLookup = (params: GetSignaturesLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getSignaturesLookupStart());
      const url = `/shared/get-signatures-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getSignaturesLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSignaturesLookupFail(err));
          reject(err);
        });
    });
  };
};

const getBoatsLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_BOATS_LOOKUP_START,
  };
};

const getBoatsLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_BOATS_LOOKUP_SUCCESS,
    data,
  };
};

const getBoatsLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_BOATS_LOOKUP_FAIL,
    error,
  };
};

export const getBoatsLookup = (params: GetBoatsLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getBoatsLookupStart());
      const url = `/shared/get-boats-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getBoatsLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getBoatsLookupFail(err));
          reject(err);
        });
    });
  };
};

const getUserInfoStart = () => {
  return {
    type: actionTypes.SHARED_GET_USER_INFO_START,
  };
};

const getUserInfoSuccess = (data: UserInfo) => {
  return {
    type: actionTypes.SHARED_GET_USER_INFO_SUCCESS,
    data,
  };
};

const getUserInfoFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_USER_INFO_FAIL,
    error,
  };
};

export const getUserInfo = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<UserInfo>((resolve, reject) => {
      dispatch(getUserInfoStart());
      const url = `/shared/get-user-info`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getUserInfoSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getUserInfoFail(err));
          reject(err);
        });
    });
  };
};

const getFormNameStart = () => {
  return {
    type: actionTypes.SHARED_GET_FORM_NAME_START,
  };
};

const getFormNameSuccess = (data: string) => {
  return {
    type: actionTypes.SHARED_GET_FORM_NAME_SUCCESS,
    data,
  };
};

const getFormNameFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_FORM_NAME_FAIL,
    error,
  };
};

export const getFormName = (params: GetFormNameRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<string>((resolve, reject) => {
      dispatch(getFormNameStart());
      const url = `/shared/get-form-name`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getFormNameSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getFormNameFail(err));
          reject(err);
        });
    });
  };
};

const getBusinessAutoAcord137sLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_START,
  };
};

const getBusinessAutoAcord137sLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_SUCCESS,
    data,
  };
};

const getBusinessAutoAcord137sLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_FAIL,
    error,
  };
};

export const getBusinessAutoAcord137sLookup = (params: GetBusinessAutoAcord137sLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getBusinessAutoAcord137sLookupStart());
      const url = `/shared/get-business-auto-acord-137s-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getBusinessAutoAcord137sLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getBusinessAutoAcord137sLookupFail(err));
          reject(err);
        });
    });
  };
};

const getPersonalUmbrellasLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_START,
  };
};

const getPersonalUmbrellasLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_SUCCESS,
    data,
  };
};

const getPersonalUmbrellasLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_FAIL,
    error,
  };
};

export const getPersonalUmbrellasLookup = (params: GetPersonalUmbrellasLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getPersonalUmbrellasLookupStart());
      const url = `/shared/get-personal-umbrellas-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getPersonalUmbrellasLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getPersonalUmbrellasLookupFail(err));
          reject(err);
        });
    });
  };
};

const getCommercialUmbrellasLookupStart = () => {
  return {
    type: actionTypes.SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_START,
  };
};

const getCommercialUmbrellasLookupSuccess = (data: DataLookup) => {
  return {
    type: actionTypes.SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_SUCCESS,
    data,
  };
};

const getCommercialUmbrellasLookupFail = (error: any) => {
  return {
    type: actionTypes.SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_FAIL,
    error,
  };
};

export const getCommercialUmbrellasLookup = (params: GetCommercialUmbrellasLookupRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<DataLookup>((resolve, reject) => {
      dispatch(getCommercialUmbrellasLookupStart());
      const url = `/shared/get-commercial-umbrellas-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getCommercialUmbrellasLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getCommercialUmbrellasLookupFail(err));
          reject(err);
        });
    });
  };
};
